import { helpers, type PluginConfiguration } from '../helpers'
import { icons } from '../icons'

export const cache: PluginConfiguration = {
  name: 'Cache',
  id: 'cache',
  icon: icons.cache,
  extra: '',
  layout: {
    type: 'table',
    columns: [['Key', 'Value']],
    searchColumnsIndex: [0, 1],
    render: (data: unknown) =>
      helpers.updateTable(cache.id, 'rewrite', {
        rows: Object.entries(data ?? {}).map(([key, value]) => ({
          data: [key, helpers.convertObjectToString(value ?? {})],
          dataAttributes: {
            'data-key': key,
            'data-value': value ?? {},
          },
        })),
        isRowClickable: true,
      }),
  },
  render: (...data: [unknown]) => cache.layout.render(...data),
  init: () => {
    document
      .querySelector(`[data-fu-tools-table-content=${cache.id}]`)
      ?.addEventListener('click', event => {
        const tableRow = (event.target as HTMLElement).closest('[fu-tools-table-row]')
        if (!tableRow) {
          return
        }

        const key = tableRow.getAttribute('data-key') ?? ''
        const value = tableRow.getAttribute('data-value') ?? '{}'

        const createdElements = helpers.createHTMLElements([
          { className: 'flex font-bold border-[#334155] border-b pb-4', content: key },
          {
            className:
              'border-[#334155] border-b py-4 cursor-pointer hover:bg-[#1e293b] transition-all duration-200',
            content: helpers.convertObjectToSanitizedDialogHTML(JSON.parse(value)),
            copyOnClick: true,
            dangerouslySetInnerHTML: true,
          },
        ])
        helpers.showModal(createdElements)
      })
  },
}
